import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getSettingsRequest, settingsUpdateRequest, resetSettingErrors, setHoursErrors, changeDeliveryData } from './actions';
import {
  settingsGetInProcessSelector,
  settingsDataSelector,
  settingsUpdateInProcessSelector,
  settingsErrorsSelector,
  settingsDeliveryZipsSelector,
  deliveryActiveTabSelector,
  settingsLoadingStatusesSelector,
  deliveryDatesSelector,
} from './selectors';

export const useSettings = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const data = useSelector(settingsDataSelector);
  const errors = useSelector(settingsErrorsSelector);
  const updateInProcess = useSelector(settingsUpdateInProcessSelector);
  const getInProcess = useSelector(settingsGetInProcessSelector);

  const deliveryZips = useSelector(settingsDeliveryZipsSelector);
  const deliveryActiveTab = useSelector(deliveryActiveTabSelector);
  const loadingStatuses = useSelector(settingsLoadingStatusesSelector);
  const deliveryDates = useSelector(deliveryDatesSelector);

  function resetErrors() {
    if (errors) {
      dispatch(resetSettingErrors());
    }
  }

  function handleUpdate(data) {
    dispatch(settingsUpdateRequest({ data, history }));
  }

  function handleGetSettings() {
    dispatch(getSettingsRequest());
  }

  const handleSetHoursErrors = (errors) => {
    setHoursErrors({
      deliveryActiveTab,
      errors,
    });
  };

  const handleChangeDeliveryDayConfig = (day, data = {}) => {
    changeDeliveryData({
      day, data, deliveryActiveTab
    });
  };

  const handleFetchDeliveryDates = (key) => {

  };

  return {
    data,
    errors,
    getInProcess,
    updateInProcess,
    handleUpdate,
    handleGetSettings,
    resetErrors,

    deliveryZips,
    deliveryActiveTab,
    loadingStatuses,
    deliveryDates,

    handleSetHoursErrors,
    handleChangeDeliveryDayConfig,
  };
};
